/**
 * Utility functions for monetary precision handling
 */

/**
 * Ensures a number has exactly 2 decimal places
 * Fixes floating-point precision issues
 */
export const twoDecimals = (value: number): number => {
  return Math.round(value * 100) / 100;
};

/**
 * Validates and normalizes a monetary value with logging
 */
export const validateMonetaryValue = (value: number, context: string): number => {
  return twoDecimals(value);
};

/**
 * Converts value to cents ensuring proper precision
 */
export const toCents = (value: number): number => {
  const normalized = twoDecimals(value);
  return Math.round(normalized * 100);
};

/**
 * Safe conversion from any value to normalized decimal
 */
export const safeToDecimal = (value: any): number => {
  if (typeof value === 'number') {
    return twoDecimals(value);
  }
  
  if (typeof value === 'string') {
    const cleanValue = value.replace(/[^\d,.-]/g, '').replace(',', '.');
    const parsed = parseFloat(cleanValue);
    return twoDecimals(isNaN(parsed) ? 0 : parsed);
  }
  
  return 0;
};